import React, { useState, useEffect } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';

const Login = ({ showLogin, showRegister, onLoginClose, onRegisterClose, onLoginSuccess, onRegisterSuccess, onLogout, onRegisterShow }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [referralCode, setReferralCode] = useState('');

  useEffect(() => {
    const googleToken = localStorage.getItem('google_access_token');
    const storedUser = JSON.parse(localStorage.getItem('userInfo'));
    const ref = localStorage.getItem('referral_code');
    console.log('Referral code from localStorage:', ref);
    if (ref) {
      setReferralCode(ref);
    }

    if (storedUser && googleToken) {
      if (!JSON.parse(localStorage.getItem('userInfo'))?.email) {
        onLoginSuccess(storedUser);
      }
    } else if (googleToken) {
      fetch('https://marketreact-ip88.onrender.com/auth/google', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ access_token: googleToken }),
      })
        .then((res) => {
          if (!res.ok) throw new Error('Invalid token response');
          return res.json();
        })
        .then((data) => {
          if (data.user.email) {
            onLoginSuccess(data.user);
            localStorage.setItem('userInfo', JSON.stringify(data.user));
            localStorage.setItem('token', data.token);
          } else {
            localStorage.removeItem('google_access_token');
            localStorage.removeItem('userInfo');
            onLogout();
          }
        })
        .catch(() => {
          console.error('Ошибка проверки Google токена');
        });
    }
  }, [onLoginSuccess, onLogout]);

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError('Заполните все поля');
      return;
    }
    try {
      const response = await axios.post('https://market.aptcloud.ru/login', { email, password });
      localStorage.setItem('token', response.data.token);
      const userInfo = response.data.user;
      onLoginSuccess(userInfo);
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
      setError('');
      setEmail('');
      setPassword('');
      onLoginClose();
    } catch (error) {
      setError(error.response?.data?.error || 'Ошибка входа');
    }
  };

  const handleRegisterSubmit = async (e) => {
    e.preventDefault();
    if (!name || !email || !password) {
      setError('Заполните все поля');
      return;
    }
    try {
      const response = await axios.post('https://market.aptcloud.ru/register', {
        email,
        password,
        name,
        referral_code: referralCode || undefined,
      });
      localStorage.setItem('token', response.data.token);
      const userInfo = response.data.user;
      onRegisterSuccess(userInfo);
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
      setError('');
      setEmail('');
      setPassword('');
      setName('');
      setReferralCode('');
      onRegisterClose();
    } catch (error) {
      setError(error.response?.data?.error || 'Ошибка регистрации');
    }
  };

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const res = await fetch('https://market.aptcloud.ru/auth/google', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ access_token: tokenResponse.access_token, referral_code: referralCode || undefined }),
        });
        if (!res.ok) throw new Error('Failed to fetch user info');
        const data = await res.json();
        if (data.user.email) {
          onLoginSuccess(data.user);
          localStorage.setItem('google_access_token', tokenResponse.access_token);
          localStorage.setItem('userInfo', JSON.stringify(data.user));
          localStorage.setItem('token', data.token);
          onLoginClose();
        }
      } catch (error) {
        setError('Ошибка входа через Google');
      }
    },
    onError: () => {
      setError('Ошибка авторизации через Google');
    },
    scope: 'email profile',
    redirect_uri: 'https://market.aptcloud.ru',
  });

  const handleSwitchToRegister = () => {
    onLoginClose();
    onRegisterShow();
  };

  return (
    <>
      {showLogin && (
        <div className="modal-overlay" onClick={onLoginClose}>
          <form className="form" onSubmit={handleLoginSubmit} onClick={(e) => e.stopPropagation()}>
            {error && <div className="error-message">{error}</div>}
            <div className="flex-column">
              <label>Email</label>
            </div>
            <div className="inputForm">
              <svg height="20" viewBox="0 0 32 32" width="20" xmlns="http://www.w3.org/2000/svg">
                <g id="Layer_3" data-name="Layer 3">
                  <path d="m30.853 13.87a15 15 0 0 0 -29.729 4.082 15.1 15.1 0 0 0 12.876 12.918 15.6 15.6 0 0 0 2.016.13 14.85 14.85 0 0 0 7.715-2.145 1 1 0 1 0 -1.031-1.711 13.007 13.007 0 1 1 5.458-6.529 2.149 2.149 0 0 1 -4.158-.759v-10.856a1 1 0 0 0 -2 0v1.726a8 8 0 1 0 .2 10.325 4.135 4.135 0 0 0 7.83.274 15.2 15.2 0 0 0 .823-7.455zm-14.853 8.13a6 6 0 1 1 6-6 6.006 6.006 0 0 1 -6 6z"></path>
                </g>
              </svg>
              <input
                type="email"
                className="input"
                placeholder="Введите ваш Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="flex-column">
              <label>Пароль</label>
            </div>
            <div className="inputForm">
              <svg height="20" viewBox="-64 0 512 512" width="20" xmlns="http://www.w3.org/2000/svg">
                <path d="m336 512h-288c-26.453125 0-48-21.523438-48-48v-224c0-26.476562 21.546875-48 48-48h288c26.453125 0 48 21.523438 48 48v224c0 26.476562-21.546875 48-48 48zm-288-288c-8.8125 0-16 7.167969-16 16v224c0 8.832031 7.1875 16 16 16h288c8.8125 0 16-7.167969 16-16v-224c0-8.832031-7.1875-16-16-16zm0 0"></path>
                <path d="m304 224c-8.832031 0-16-7.167969-16-16v-80c0-52.929688-43.070312-96-96-96s-96 43.070312-96 96v80c0 8.832031-7.167969 16-16 16s-16-7.167969-16-16v-80c0-70.59375 57.40625-128 128-128s128 57.40625 128 128v80c0 8.832031-7.167969 16-16 16zm0 0"></path>
              </svg>
              <input
                type="password"
                className="input"
                placeholder="Введите ваш пароль"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <svg viewBox="0 0 576 512" height="1em" xmlns="http://www.w3.org/2000/svg">
                <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"></path>
              </svg>
            </div>
            <div className="flex-row">
              <div>
                <input type="checkbox" id="remember-me" />
                <label htmlFor="remember-me">Запомнить меня</label>
              </div>
              <span className="span">Забыли пароль?</span>
            </div>
            <button className="button-submit" type="submit">
              Войти
            </button>
            <p className="p">
              Нет аккаунта?{' '}
              <span className="span" onClick={handleSwitchToRegister}>
                Зарегистрироваться
              </span>
            </p>
          </form>
        </div>
      )}
      {showRegister && (
        <div className="modal-overlay" onClick={onRegisterClose}>
          <form className="form" onSubmit={handleRegisterSubmit} onClick={(e) => e.stopPropagation()}>
            {error && <div className="error-message">{error}</div>}
            <div className="flex-column">
              <label>Имя</label>
            </div>
            <div className="inputForm">
              <svg height="20" viewBox="0 0 32 32" width="20" xmlns="http://www.w3.org/2000/svg">
                <g id="Layer_3" data-name="Layer 3">
                  <path d="m30.853 13.87a15 15 0 0 0 -29.729 4.082 15.1 15.1 0 0 0 12.876 12.918 15.6 15.6 0 0 0 2.016.13 14.85 14.85 0 0 0 7.715-2.145 1 1 0 1 0 -1.031-1.711 13.007 13.007 0 1 1 5.458-6.529 2.149 2.149 0 0 1 -4.158-.759v-10.856a1 1 0 0 0 -2 0v1.726a8 8 0 1 0 .2 10.325 4.135 4.135 0 0 0 7.83.274 15.2 15.2 0 0 0 .823-7.455zm-14.853 8.13a6 6 0 1 1 6-6 6.006 6.006 0 0 1 -6 6z"></path>
                </g>
              </svg>
              <input
                type="text"
                className="input"
                placeholder="Введите ваше имя"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="flex-column">
              <label>Email</label>
            </div>
            <div className="inputForm">
              <svg height="20" viewBox="0 0 32 32" width="20" xmlns="http://www.w3.org/2000/svg">
                <g id="Layer_3" data-name="Layer 3">
                  <path d="m30.853 13.87a15 15 0 0 0 -29.729 4.082 15.1 15.1 0 0 0 12.876 12.918 15.6 15.6 0 0 0 2.016.13 14.85 14.85 0 0 0 7.715-2.145 1 1 0 1 0 -1.031-1.711 13.007 13.007 0 1 1 5.458-6.529 2.149 2.149 0 0 1 -4.158-.759v-10.856a1 1 0 0 0 -2 0v1.726a8 8 0 1 0 .2 10.325 4.135 4.135 0 0 0 7.83.274 15.2 15.2 0 0 0 .823-7.455zm-14.853 8.13a6 6 0 1 1 6-6 6.006 6.006 0 0 1 -6 6z"></path>
                </g>
              </svg>
              <input
                type="email"
                className="input"
                placeholder="Введите ваш Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="flex-column">
              <label>Пароль</label>
            </div>
            <div className="inputForm">
              <svg height="20" viewBox="-64 0 512 512" width="20" xmlns="http://www.w3.org/2000/svg">
                <path d="m336 512h-288c-26.453125 0-48-21.523438-48-48v-224c0-26.476562 21.546875-48 48-48h288c26.453125 0 48 21.523438 48 48v224c0 26.476562-21.546875 48-48 48zm-288-288c-8.8125 0-16 7.167969-16 16v224c0 8.832031 7.1875 16 16 16h288c8.8125 0 16-7.167969 16-16v-224c0-8.832031-7.1875-16-16-16zm0 0"></path>
                <path d="m304 224c-8.832031 0-16-7.167969-16-16v-80c0-52.929688-43.070312-96-96-96s-96 43.070312-96 96v80c0 8.832031-7.167969 16-16 16s-16-7.167969-16-16v-80c0-70.59375 57.40625-128 128-128s128 57.40625 128 128v80c0 8.832031-7.167969 16-16 16zm0 0"></path>
              </svg>
              <input
                type="password"
                className="input"
                placeholder="Введите ваш пароль"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <svg viewBox="0 0 576 512" height="1em" xmlns="http://www.w3.org/2000/svg">
                <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"></path>
              </svg>
            </div>
            {referralCode && (
              <div className="flex-column">
                <label>Реферальный код</label>
                <div className="inputForm">
                  <input
                    type="text"
                    className="input"
                    placeholder="Реферальный код"
                    value={referralCode}
                    readOnly
                  />
                </div>
              </div>
            )}
            <button className="button-submit" type="submit">
              Зарегистрироваться
            </button>
            <p className="p">
              Уже есть аккаунт?{' '}
              <span className="span" onClick={onLoginClose}>
                Войти
              </span>
            </p>
          </form>
        </div>
      )}
    </>
  );
};

export default Login;
